module.exports = __webpack_public_path__ + "img/IMG_1565.0684c992.jpg";